import client from "./Client";

const getTerms = (schoolId) =>
  client.get(`/school/${schoolId}/terms`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

const getSingleTerm = (schoolId, termId) =>
  client.get(`/school/${schoolId}/term/${termId}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

export default {
  getTerms,
  getSingleTerm
};
